import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight as ArrowRightIcon } from 'lucide-react';
import './Home.css';
import '../styles/button-override.css';
import logoNoTag from '../assets/playmaker-logo.png';
import Footer from './Footer';

const Home = ({ isAuthenticated, userInfo }) => {
  return (
    <div className="landing-container">
      <section className="hero-section">
        <img src={logoNoTag} alt="PlayMaker logo" className="hero-logo" />
        <h1 className="hero-headline">Dynamic, branded sports images—automatically.</h1>
        <p className="hero-subheadline">Empower your club or league to increase revenue and keep athletes & parents engaged all year.</p>

        <div className="cta-wrapper">
          {isAuthenticated ? (
            <Link 
              to="/dashboard" 
              className="primary-btn"
              style={{
                backgroundColor: "#F6921E",
                color: "white",
                padding: "10px 24px",
                borderRadius: "6px",
                fontWeight: "500",
                transition: "all 0.2s",
                display: "inline-flex",
                alignItems: "center",
                textDecoration: "none"
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e58418"}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#F6921E"}
            >
              Open Dashboard
            </Link>
          ) : (
            <>
              <Link 
                to="/contact" 
                className="primary-btn"
                style={{
                  backgroundColor: "#F6921E",
                  color: "white",
                  padding: "10px 24px",
                  borderRadius: "6px",
                  fontWeight: "500",
                  transition: "all 0.2s",
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  marginRight: "16px"
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e58418"}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#F6921E"}
              >
                Request a demo
              </Link>
              <Link 
                to="/login" 
                className="secondary-btn"
                style={{
                  backgroundColor: "white",
                  color: "#F6921E",
                  padding: "10px 24px",
                  borderRadius: "6px",
                  fontWeight: "500",
                  transition: "all 0.2s",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  textDecoration: "none",
                  border: "1px solid #F6921E"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#fff8f2";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                }}
              >
                Client login <ArrowRightIcon size={14} />
              </Link>
            </>
          )}
        </div>
      </section>

      {/* Bottom navigation */}
      <Footer />
    </div>
  );
};

export default Home;